import { useState } from "react";
import ComplaintForm from "./ComplaintForm";

const Complaint = () => {
  const [formData, setFormData] = useState({
    studentName: "",
    studentEmail: "",
    studentRollNumber: "",
    studentPhoneNumber: "",
    studentDepartment: "",
    studentSection: "",
    subject: "",
    message: "",
    terms: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.terms) {
      console.log(formData);
    } else {
      alert("Please fill in all fields and agree to the terms.");
    }
  };

  return (
    <div id="register" className="form-1">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="text-container">
              <h2>Submit the complaint</h2>
              <p>
                It's easy to submit a complaint, just fill out the form with
                your details and click submit. Provide your name, email, roll
                number, phone number, department, section, the subject of your
                complaint, and a detailed message. Make sure to agree to the
                Privacy Policy and Terms & Conditions by checking the box. Your
                complaint will be registered and reviewed promptly.
              </p>
              <ul className="list-unstyled li-space-lg">
                <li className="media">
                  <i className="fas fa-square"></i>
                  <div className="media-body">
                    <strong>Your information</strong> is required to submit the
                    complaint.
                  </div>
                </li>
                <li className="media">
                  <i className="fas fa-square"></i>
                  <div className="media-body">
                    <strong>It's safe with us</strong> and will not be used for
                    marketing.
                  </div>
                </li>
                <li className="media">
                  <i className="fas fa-square"></i>
                  <div className="media-body">
                    <strong>You will receive</strong> a confirmation email in
                    less than 24 hours.
                  </div>
                </li>
                <li className="media">
                  <i className="fas fa-square"></i>
                  <div className="media-body">
                    <strong>Agree to the terms</strong> by checking the box for
                    the Privacy Policy and Terms & Conditions.
                  </div>
                </li>
                <li className="media">
                  <i className="fas fa-square"></i>
                  <div className="media-body">
                    <strong>Double-check your information</strong> before
                    submitting to ensure accuracy.
                  </div>
                </li>
                <li className="media">
                  <i className="fas fa-square"></i>
                  <div className="media-body">
                    <strong>Use a valid email address</strong> to receive
                    important updates regarding your complaint.
                  </div>
                </li>
                <li className="media">
                  <i className="fas fa-square"></i>
                  <div className="media-body">
                    <strong>Include specific details</strong> in your message to
                    help us address your complaint effectively.
                  </div>
                </li>
                <li className="media">
                  <i className="fas fa-square"></i>
                  <div className="media-body">
                    <strong>Check your spam folder</strong> if you don't see the
                    confirmation email within 24 hours.
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-6">
            <ComplaintForm
              formData={formData}
              handleSubmit={handleSubmit}
              handleChange={handleChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Complaint;
